import React from "react";
import {Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography} from "@mui/material";
import ProductCard from "../recap/ProductCardMobile";
import TotalRecapMobileView from "../recap/TotalRecapMobileView";
import ProductRecapRow from "../recap/ProductRecapRow";
import ReductionRecapRow from "../recap/ReductionRecapRow";
import TotalRecapRows from "../recap/TotalRecapRows";

export default function BookingContent({reservation, categories, isMobile, calculateTotal}) {
    if (!reservation) return null;

    return (
        <Box sx={{width: "calc(100% - 32px)", mx: "auto", my: 2}}>
            <Typography variant="subtitle1" fontWeight="bold" sx={{mb: 1}}>
                Contenu de la réservation
            </Typography>

            {isMobile ? <React.Fragment>
                    {categories.map((cat) =>
                        reservation.products.some((p) => p.category.id === cat.id) && (
                            <Box key={cat.id} mt={2}>
                                <Box sx={{
                                    bgcolor: 'primary.main',
                                    p: 1,
                                    color: 'primary.contrastText',
                                    borderRadius: "8px 8px 0 0"
                                }}>
                                    <Typography variant="subtitle1" textAlign="center">{cat.name}</Typography>
                                </Box>

                                <ProductCard
                                    products={reservation.products.filter((p) => p.category.id === cat.id).map((bp) => ({
                                        name: bp.product.name,
                                        datetimeStart: bp.datetimeStart,
                                        datetimeEnd: bp.datetimeEnd,
                                        price: bp.priceAtMoment * (1 + bp.product.tva / 100),
                                        quantity: bp.quantity,
                                        discountType: bp.discountType,
                                        discountValue: bp.discountValue,
                                        options: reservation.options.filter((bpo) => bpo.bookingProductId === bp.id).map((bpo) => ({
                                            name: bpo.option.name,
                                            quantity: bpo.quantity,
                                            price: bpo.priceAtMoment * (1 + bpo.option.tva / 100)
                                        }))
                                    }))}/>
                            </Box>
                        ))}

                    <TotalRecapMobileView total={calculateTotal()}
                                          depositAmount={reservation.depositAmount}/>
                </React.Fragment>
                :
                <React.Fragment>
                    <TableContainer component={Paper} sx={{mt: 2}}>
                        <Table>
                            <TableHead>
                                <TableRow sx={{background: "#1e1e1e", whiteSpace: "nowrap"}}>
                                    <TableCell sx={{
                                        color: "white",
                                        fontWeight: "bold",
                                        width: "100%",
                                        minWidth: "200px"
                                    }}>Produit</TableCell>
                                    <TableCell sx={{color: "white", fontWeight: "bold"}} align="right">Qté</TableCell>
                                    <TableCell sx={{color: "white", fontWeight: "bold"}} align="right">Prix
                                        unit. HT</TableCell>
                                    <TableCell sx={{color: "white", fontWeight: "bold"}} align="right">Taux
                                        TVA</TableCell>
                                    <TableCell sx={{color: "white", fontWeight: "bold"}} align="right">Montant
                                        TTC</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {categories.map((cat) => {
                                    const products = reservation.products.filter((p) => p.category.id === cat.id);

                                    return products.length > 0 ? (
                                        <React.Fragment key={cat.id}>
                                            <TableRow>
                                                <TableCell colSpan={5}
                                                           sx={{background: "lightgray"}}>{cat.name}</TableCell>
                                            </TableRow>

                                            {products.map((bp, index) => {
                                                const options = reservation.options.filter((bpo) => bpo.bookingProductId === bp.id);
                                                return <React.Fragment key={index}>
                                                    <ProductRecapRow
                                                        name={bp.product.name}
                                                        datetimeStart={bp.datetimeStart}
                                                        datetimeEnd={bp.datetimeEnd}
                                                        unitPrice={bp.priceAtMoment}
                                                        quantity={bp.quantity}
                                                        tvaRate={bp.product.tva}
                                                        options={options.map(bpo => ({
                                                            name: bpo.option.name,
                                                            quantity: bpo.quantity,
                                                            price: bpo.priceAtMoment,
                                                            tva: bpo.option.tva
                                                        }))}
                                                    />
                                                    <ReductionRecapRow
                                                        quantity={bp.quantity}
                                                        price={bp.priceAtMoment * (1 + bp.product.tva / 100)}
                                                        discountType={bp.discountType}
                                                        discountValue={bp.discountValue}
                                                        options={options.map(bpo => ({
                                                            name: bpo.option.name,
                                                            quantity: bpo.quantity,
                                                            price: bpo.priceAtMoment * (1 + bpo.option.tva / 100),
                                                            tva: bpo.option.tva
                                                        }))}
                                                    />
                                                </React.Fragment>
                                            })}
                                        </React.Fragment>
                                    ) : <React.Fragment/>
                                })}
                                <TotalRecapRows total={calculateTotal()}
                                                depositAmount={reservation.depositAmount}/>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </React.Fragment>
            }
        </Box>
    );
}
